import styled from "styled-components"

import { ReactComponent as SensorIcon } from "assets/svg/water_leak_sensor.svg"

import { EmptyState } from "components/common/EmptyState"

const SensorGlyph = styled(SensorIcon)`
  path {
    stroke: #334155;
  }
`

export const SensorsEmptyState = () => (
  <EmptyState
    icon={<SensorGlyph />}
    title="No Sensors Yet"
    description="When wireless sensors are paired to your thermostats, they'll show up here."
  />
)
